import {NavigateFunction, NavigateOptions} from "react-router-dom"

let navigate: NavigateFunction | null = null

export const setNavigator = (fn: NavigateFunction) => {
	navigate = fn
}

export const navigateTo = (path: string, options?: NavigateOptions) => {
	if (navigate) {
		navigate(path, options)
	} else {
		console.warn("Navigator not initialized")
	}
}
